export { default as CommercialFarming } from './CommercialFarming';
export { default as Hotel } from './Hotel';
export { default as Industrial } from './Industrial';
export { default as LandDevelopment } from './LandDevelopment';
export { default as Medical } from './Medical';
export { default as Offices } from './Offices';
export { default as Other } from './Other';
export { default as Retail } from './Retail';
export { default as Showrooms } from './Showrooms';
